import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { acNameToEmoji, acShortcutToEmoji } from '../../utils/confluence/emoji';
import { emoji as emojiFactory } from '../../next-schema/generated/nodeTypes';
import { uuid } from '../../utils/uuid';

/**
 * @name emoji_node
 */

export var emoji = emojiFactory({
  parseDOM: [
  // Handle copy/paste beautiful panel from renderer />
  {
    tag: 'div.ak-editor-panel__icon span',
    ignore: true
  }, {
    tag: 'span[data-emoji-short-name]',
    getAttrs: function getAttrs(domNode) {
      var dom = domNode;
      return {
        shortName: dom.getAttribute('data-emoji-short-name') || emoji.attrs.shortName.default,
        id: dom.getAttribute('data-emoji-id') || emoji.attrs.id.default,
        text: dom.getAttribute('data-emoji-text') || emoji.attrs.text.default
      };
    }
  },
  // Handle copy/paste from old <ac:emoticon />
  {
    tag: 'img[data-emoticon-name]',
    getAttrs: function getAttrs(dom) {
      return acNameToEmoji(dom.getAttribute('data-emoticon-name'));
    }
  },
  // Handle copy/paste from old <ac:hipchat-emoticons />
  {
    tag: 'img[data-hipchat-emoticon]',
    getAttrs: function getAttrs(dom) {
      return acShortcutToEmoji(dom.getAttribute('data-hipchat-emoticon'));
    }
  },
  // Handle copy/paste from bitbucket's <img class="emoji" />
  {
    tag: 'img.emoji[data-emoji-short-name]',
    getAttrs: function getAttrs(domNode) {
      var dom = domNode;
      return {
        shortName: dom.getAttribute('data-emoji-short-name') || emoji.attrs.shortName.default,
        id: dom.getAttribute('data-emoji-id') || emoji.attrs.id.default,
        text: dom.getAttribute('data-emoji-text') || emoji.attrs.text.default
      };
    }
  }],
  toDOM: function toDOM(node) {
    var _node$attrs = node.attrs,
      shortName = _node$attrs.shortName,
      id = _node$attrs.id,
      text = _node$attrs.text;
    var attrs = {
      'data-emoji-short-name': shortName,
      'data-emoji-id': id,
      'data-emoji-text': text,
      contenteditable: 'false'
    };
    return ['span', attrs, text];
  }
});
export var emojiWithLocalId = emojiFactory({
  parseDOM: [
  // Handle copy/paste beautiful panel from renderer />
  {
    tag: 'div.ak-editor-panel__icon span',
    ignore: true
  }, {
    tag: 'span[data-emoji-short-name]',
    getAttrs: function getAttrs(domNode) {
      var dom = domNode;
      return {
        shortName: dom.getAttribute('data-emoji-short-name') || emoji.attrs.shortName.default,
        id: dom.getAttribute('data-emoji-id') || emoji.attrs.id.default,
        text: dom.getAttribute('data-emoji-text') || emoji.attrs.text.default,
        localId: uuid.generate()
      };
    }
  },
  // Handle copy/paste from old <ac:emoticon />
  {
    tag: 'img[data-emoticon-name]',
    getAttrs: function getAttrs(dom) {
      var attrs = acNameToEmoji(dom.getAttribute('data-emoticon-name'));
      return _objectSpread(_objectSpread({}, attrs), {}, {
        localId: uuid.generate()
      });
    }
  },
  // Handle copy/paste from old <ac:hipchat-emoticons />
  {
    tag: 'img[data-hipchat-emoticon]',
    getAttrs: function getAttrs(dom) {
      var attrs = acShortcutToEmoji(dom.getAttribute('data-hipchat-emoticon'));
      return _objectSpread(_objectSpread({}, attrs), {}, {
        localId: uuid.generate()
      });
    }
  },
  // Handle copy/paste from bitbucket's <img class="emoji" />
  {
    tag: 'img.emoji[data-emoji-short-name]',
    getAttrs: function getAttrs(domNode) {
      var dom = domNode;
      return {
        shortName: dom.getAttribute('data-emoji-short-name') || emoji.attrs.shortName.default,
        id: dom.getAttribute('data-emoji-id') || emoji.attrs.id.default,
        text: dom.getAttribute('data-emoji-text') || emoji.attrs.text.default,
        localId: uuid.generate()
      };
    }
  }],
  toDOM: function toDOM(node) {
    var _node$attrs3;
    var _node$attrs2 = node.attrs,
      shortName = _node$attrs2.shortName,
      id = _node$attrs2.id,
      text = _node$attrs2.text;
    var attrs = {
      'data-emoji-short-name': shortName,
      'data-emoji-id': id,
      'data-emoji-text': text,
      contenteditable: 'false',
      'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
    };
    return ['span', attrs, text];
  }
});